module.exports = __webpack_public_path__ + "static/media/squadroll.ec91f156.png";